import { combineReducers } from '@reduxjs/toolkit';
import loadingFullScreenSlice from './loadingFullScreen/loadingFullScreenSlice';
import { CompaniesReducer, companiesSlice } from './company/companySlice';
import accountSlice from './account/accountSlice';

const rootReducer = combineReducers({
  [loadingFullScreenSlice.name]: loadingFullScreenSlice.reducer,
  [companiesSlice.name]: CompaniesReducer,
  [accountSlice.name]: accountSlice.reducer,
});

export default rootReducer;
